/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useMemo } from "react";
// ───────── FIRESTORE (temporarily disabled) ─────────
// import { db } from "../firebase";
// import { collection, getDocs } from "firebase/firestore";
// ───────── LOCAL JSON hook ─────────
import { useAgentsLocal } from "./useAgentsLocal";

import { SAMPLE_AGENTS } from "./LexAcquireprofile";
import "./lexacquire.css";

 import {
     FiCompass,
     FiAward,         // <- replaced FiTrophy
     FiStar,
     FiClock,
     FiTrendingUp,
     FiEye,
     FiThumbsUp,
     FiSearch,
   } from "react-icons/fi";

   import { useNavigate } from "react-router-dom";

/* ───────── helpers ───────── */
const safe = (v) => (v == null ? "" : v);

/* Accept legacy or scraped objects */
const normalise = (raw) => {
  if (raw.name) return raw; // legacy shape

  return {
    id: raw.slug || raw.agent_name,
    name: safe(raw.agent_name),
    description: safe(raw.tagline),
    industry: safe(raw.industry), // used for chips
    category: safe(raw.category),
    logo: safe(raw.logo_url),
    url: safe(raw.url),
    website_url: safe(raw.website_url),
    buzz: safe(raw.buzz),
    overview: safe(raw.overview),
    key_features: raw.key_features || [],
    use_cases: raw.use_cases || [],
    _raw: raw,
  };
};

/* ───────── component ───────── */
export default function Acquire() {




  /* data (local JSON) */
  const { agents: rawAgents, loading } = useAgentsLocal();
  const agents = useMemo(() => rawAgents.map(normalise), [rawAgents]);

    /* UI state router */
    const [filter, setFilter] = useState(null);
    const [query, setQuery] = useState("");
    const [selected, setSelected] = useState(null);
    const navigate = useNavigate();
  
    // ─── Tabs definition & state ───
    const tabs = [
      { key: "Landscape", icon: <FiCompass /> },
      { key: "Leaderboard", icon: <FiAward />  },
      { key: "Featured",  icon: <FiStar /> },
      { key: "Newest",    icon: <FiClock /> },
      { key: "Trending",  icon: <FiTrendingUp /> },
      { key: "Most Viewed",icon:<FiEye /> },
      { key: "Most Voted", icon:<FiThumbsUp /> },
    ];
    const [activeTab, setActiveTab] = useState("null");
 
  /* ────── Firestore fetch (kept for later) ──────
  useEffect(() => {
    (async () => {
      try {
        const snap = await getDocs(collection(db, "market_agents"));
        const data = snap.size
          ? snap.docs.map((d) => ({ id: d.id, ...d.data() }))
          : SAMPLE_AGENTS;
        setAgents(data.map(normalise));
      } catch (e) {
        console.error(e);
        setAgents(SAMPLE_AGENTS.map(normalise));
      } finally {
        setLoading(false);
      }
    })();
  }, []);
  ──────────────────────────────────────────────── */

  /* unique industries → chips */
  const industries = useMemo(() => {
    const set = new Set();
    agents.forEach((a) => a.industry && set.add(a.industry));
    return Array.from(set).sort();
  }, [agents]);

  /* filtered + searched list */
  const list = useMemo(
    () =>
      agents.filter(
        (a) =>
          (!filter || a.industry === filter) &&
          (!query.trim() ||
            a.name.toLowerCase().includes(query.toLowerCase()) ||
            a.description.toLowerCase().includes(query.toLowerCase()))
      ),
    [agents, filter, query]
  );

  /* ───────── render ───────── */
  return (
    <div className="lexacq-container">
      <nav className="lexacq-topbar">
        {/* Left: tabs */}
        <div className="lexacq-tabbar">
          {tabs.map(({key,icon}) => (
            <button
              key={key}
              className={`tab-item ${activeTab===key?"active":""}`}
               onClick={() => {
                   setActiveTab(key);
                   // build a URL-safe slug from the key:
                   const slug = key.toLowerCase().replace(/\s+/g, "-");
                 navigate(`/lexacquire/${slug}`);
                 }}
            >
              <span className="tab-icon">{icon}</span>
              {key}
            </button>
          ))}
        </div>

        {/* Right: title, search, buttons */}
        <div className="lexacq-header-inline">
         


          <input
            className="lexacq-search-input"
            placeholder="Search agents…"
            value={query}
            onChange={e=>setQuery(e.target.value)}
          />

<button
          className="lexacq-btn-request"
          onClick={() => navigate("/lexacquire/request")}
        >
          Request
        </button>
          <button
          className="lexacq-btn-submit"
          onClick={() => navigate("/lexacquire/submit")}
        >
          Submit
        </button>
        </div>
      </nav>



      {/* industry chips */}
      <div className="lexacq-tags">
        <button
          className={`tag-chip ${!filter ? "active" : ""}`}
          onClick={() => setFilter(null)}
        >
          View All
        </button>
        {industries.map((ind) => (
          <button
            key={ind}
            className={`tag-chip ${filter === ind ? "active" : ""}`}
            onClick={() => setFilter(filter === ind ? null : ind)}
          >
            {ind}
          </button>
        ))}
      </div>

      {/* grid */}
      {loading ? (
        <p className="lexacq-note">Loading…</p>
      ) : list.length === 0 ? (
        <p className="lexacq-note">No agents match.</p>
      ) : (
        <div className="lexacq-grid">
          {list.map((a) => (
            <div
              key={a.id}
              className="agent-card"
              onClick={() => setSelected(a)}
            >
              {a.logo && <img src={a.logo} alt={a.name} className="agent-logo" />}
              <h2 className="agent-name">{a.name}</h2>
              <p className="agent-desc">{a.description}</p>
              <div className="agent-meta">
                {a.industry && <span>🏷 {a.industry}</span>}
                {a.buzz && <span>🔥 {a.buzz}</span>}
              </div>
            </div>
          ))}
        </div>
      )}

      {/* details modal */}
      {selected && (
        <div className="agent-modal" onClick={() => setSelected(null)}>
          <div
            className="agent-modal-content"
            onClick={(e) => e.stopPropagation()}
          >
            <button
              className="agent-modal-close"
              onClick={() => setSelected(null)}
            >
              ×
            </button>

            {selected.logo && (
              <img
                src={selected.logo}
                alt={selected.name}
                className="agent-modal-logo"
              />
            )}

            <h2>{selected.name}</h2>
            <p>{selected.description}</p>

            <p>
              <strong>Industry:</strong> {selected.industry || "—"}
            </p>
            <p>
              <strong>Category:</strong> {selected.category || "—"}
            </p>
            {selected.buzz && (
              <p>
                <strong>Buzz:</strong> {selected.buzz}
              </p>
            )}

            {selected.overview && (
              <>
                <h3>Overview</h3>
                <p>{selected.overview}</p>
              </>
            )}

            {selected.key_features.length > 0 && (
              <>
                <h3>Key Features</h3>
                <ul>
                  {selected.key_features.map((f) => (
                    <li key={f}>{f}</li>
                  ))}
                </ul>
              </>
            )}

            {selected.use_cases.length > 0 && (
              <>
                <h3>Use Cases</h3>
                <ul>
                  {selected.use_cases.map((u) => (
                    <li key={u}>{u}</li>
                  ))}
                </ul>
              </>
            )}

            <div className="agent-modal-links">
              <a href={selected.url} target="_blank" rel="noreferrer">
                
              </a>
              {selected.website_url && (
                <>
                  {" • "}
                  <a
                    href={selected.website_url}
                    target="_blank"
                    rel="noreferrer"
                  >
                    Website ↗
                  </a>
                </>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
